import React from 'react';
import { Box, Typography, Chip, Card, CardContent } from '@mui/material';
import { styled } from '@mui/system';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const CarouselImage = styled('img')({
  width: '100%',
  height: '400px',
  borderRadius: '16px',
  objectFit: 'cover',
});

const StyledCard = styled(Card)({
  borderRadius: '16px',
  boxShadow: 'none',
  backgroundColor: 'transparent',
});

const ProjectCard = ({ title, description, techStack, images }) => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <StyledCard>
      <Box sx={{ borderRadius: '16px', overflow: 'hidden', mb: 2, width: '400px' }}>
        <Slider {...settings}>
          {images.map((img, idx) => (
            <Box key={idx}>
              <CarouselImage src={img} alt={`project-image-${idx}`} loading="lazy" />
            </Box>
          ))}
        </Slider>
      </Box>

      <CardContent sx={{ px: 0 }}>
        <Typography variant="h6" sx={{ mb: 1, fontWeight: 500 }} textAlign={'left'}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: '#666', mb: 2 ,fontSize:12}} textAlign={'left'}>
          {description}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }} textAlign={'left'}>
          {techStack.map((tech, idx) => (
            <Chip
              key={idx}
              label={tech}
              sx={{
                backgroundColor: '#f5f6ff',
                color: '#182cd4',
                fontSize: '12px',
                fontWeight: 400,
              }}
            />
          ))}
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default ProjectCard;
